import * as Yup from 'yup';

const LoginSchema = Yup.object().shape({
    email : Yup.string().email("invalid email").required(),
    password : Yup.string().min(8).required(),
})

export default LoginSchema;